/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1DriverSegment } from '../../entities/v1/DriverSegment'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const v1DriverSegmentSchema = z.enum(['new', 'reactivated']) as unknown as ToZod<V1DriverSegment>